import React, {useEffect, useState} from "react";
import ModalPopUp from '../../../module/modalPopUp';
import {StepComponent} from '../../../module/step_component';
import {updateHeader, updateUrl} from '../../../store/actions/main';
import {updateEditPforte} from '../../../store/actions/pforten';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import {pforte_auswahl} from '../../../../assets/images/data';
import ImageSlider from '../../../module/imageSlider';
import {ProductInfo} from '../../../module/productInfo';

const Index = (props) => {

   const [showModalStepper, setShowModalStepper] = useState(false);
   const [showModalInfo, setShowModalInfo] = useState(false);
   const [showModalImages, setModalImages] = useState(false);

   const closeModal = () => setShowModalStepper(false);
   const closeModalInfo = () => setShowModalInfo(false);
   const closeModalImages = () => setModalImages(false);

   useEffect(() => {
        updateItems();
   })

   const updateItems = () => {
      props.updateHeader('Pforten');
      updateEdit();
   }

   const showStepper = ev => {
      let titel = ev.currentTarget.getAttribute('titel');
      props.updateUrl(titel);
      setShowModalStepper(true);
   }

   const showInfo = () => setShowModalInfo(true);
   const showImages = () => setModalImages(true);

   const updateEdit = () => {
      let button = document.querySelector('.product_main_wrapper .button');
         if (props.isEdit) {
            button.click();
            props.updateEdit();
         }
   }


      return (
           <div className="product_main_wrapper">
               <div className='product_wrapper'>
                  <div className='inner-modell-wrapper-pforte'>
                     <ImageSlider
                        showImages={showImages}
                        imageposter={pforte_auswahl.portfolio}
                     />
                     <div className="button-wrapper">
                           <Button onClick={showStepper} titel="Pforte" className='button'>Konfigurator starten</Button>
                           <Button onClick={showInfo} className='button info'>Mehr Informationen</Button>
                     </div>
                  </div>
               </div>
                  <ModalPopUp
                     title="Pforte-Bilder"
                     class='modell'
                     component={<ImageSlider showModalImages={showModalImages} imageposter={pforte_auswahl.portfolio} />}
                     showModal={showModalImages}
                     hideModal={closeModalImages}
                  />
                  <ModalPopUp
                     title="Pforte"
                     class='modell'
                     component={<StepComponent />}
                     showModal={showModalStepper}
                     hideModal={closeModal}
                  />
                  <ModalPopUp
                     title="Produktbeschreibung"
                     class='modell'
                     component={<ProductInfo
                                 type="eine Pforte"
                                 desc={pforte_auswahl.desc}
                                 desc_items={pforte_auswahl.content}
                                 price={`Ab ${props.price.toFixed(2)}€`}
                                 />}
                     showModal={showModalInfo}
                     hideModal={closeModalInfo}
                  />
            </div>
       )
}

const mapStateToProps = state => {
   return {
      isEdit: state.pfortenReducer.data.isEdit,
      price: state.pfortenReducer.data.modell[0].price
   }
}

const mapStateToDispatch = dispatch => {
    return {
        updateHeader: ev => dispatch(updateHeader(ev)),
        updateUrl: ev => dispatch(updateUrl(ev)),
        updateEdit: () => dispatch(updateEditPforte())
    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Index);

